import type { ComputedRef, Ref } from "vue";
import type { ThemeOptionsData } from "~/features/cms/data/useThemeOptions";

type ThemeOptionsRef =
  | Ref<ThemeOptionsData | undefined | null>
  | ComputedRef<ThemeOptionsData | undefined | null>;

const normalizeFaviconType = (faviconUrl?: string | null, configuredType?: string | null) => {
  const normalizedConfiguredType = String(configuredType || "").trim().toLowerCase();
  const normalizedUrl = String(faviconUrl || "").trim().toLowerCase();

  if (normalizedUrl.endsWith(".png")) {
    return "image/png";
  }

  if (normalizedUrl.endsWith(".svg")) {
    return "image/svg+xml";
  }

  if (normalizedUrl.endsWith(".ico")) {
    return "image/x-icon";
  }

  return normalizedConfiguredType || "image/x-icon";
};

export const useGlobalThemeHead = (themeOptions: ThemeOptionsRef) => {

  useHead(() => {
    const faviconUrl = String(themeOptions.value?.favicon_url || "").trim();

    if (!faviconUrl) {
      return {};
    }

    return {
      link: [
        {
          key: "theme-favicon",
          rel: "icon",
          href: faviconUrl,
          type: normalizeFaviconType(faviconUrl, themeOptions.value?.favicon_type),
        },
      ],
    };
  });
};
